/**
 * BirdieSense footer newsletter helpers.
 * Lets Shopify handle captcha + native POST (AJAX/iframe skip captcha tokens), then shows success UI.
 * BirdieSense 页脚订阅辅助：交给 Shopify 处理验证码与原生提交（避免 AJAX/iframe 丢 token），再展示成功状态。
 */
(function () {
  var SUCCESS_MESSAGE = "You're in! Practice tips and updates are on the way.";

  function getStatusEl(root) {
    return root.querySelector('[data-newsletter-status]');
  }

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function setStatus(root, type, message) {
    var status = getStatusEl(root);
    if (!status) return;

    status.hidden = false;
    status.textContent = message;
    status.classList.remove(
      'birdiesense-footer-newsletter__status--success',
      'birdiesense-footer-newsletter__status--error'
    );
    status.classList.add('birdiesense-footer-newsletter__status--' + type);
    root.classList.toggle('is-success', type === 'success');
    root.classList.toggle('is-error', type === 'error');
  }

  function ensureReturnTo(form) {
    var input = form.querySelector('input[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = window.location.pathname + window.location.search;
  }

  function syncFormAvailability() {
    var roots = document.querySelectorAll('[data-birdiesense-newsletter]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var form = root.querySelector('form');
      if (!form) continue;

      if (isVisible(form)) {
        root.removeAttribute('inert');
        form.removeAttribute('aria-hidden');
        ensureReturnTo(form);
      } else {
        // Hidden mobile/desktop duplicate must not take focus or captcha wire-up.
        root.setAttribute('inert', '');
        form.setAttribute('aria-hidden', 'true');
      }
    }

    // Theme "Join our email list" block stays in DOM but is CSS-hidden — disable it.
    var legacy = document.querySelectorAll('.footer-content form[action*="/contact"]');
    for (var j = 0; j < legacy.length; j++) {
      var legacyForm = legacy[j];
      var legacyRoot = legacyForm.closest('.footer-content') || legacyForm.parentElement;
      if (legacyRoot) legacyRoot.setAttribute('inert', '');
      legacyForm.setAttribute('aria-hidden', 'true');
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var root = form.closest('[data-birdiesense-newsletter]');
    if (!root || !isVisible(form)) return;

    // Do not preventDefault — Shopify hCaptcha must attach a token on the real submit.
    ensureReturnTo(form);
    form.classList.add('is-loading');
    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.setAttribute('aria-busy', 'true');
    }
  }

  function showPostedSuccessIfNeeded() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') !== 'true' && params.get('contact_posted') !== 'true') {
        return;
      }
    } catch (e) {
      return;
    }

    var roots = document.querySelectorAll('[data-birdiesense-newsletter]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var form = root.querySelector('form');
      if (!form || !isVisible(form)) continue;
      setStatus(root, 'success', SUCCESS_MESSAGE);
      try {
        root.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } catch (err) {
        /* ignore */
      }
      break;
    }

    try {
      params.delete('customer_posted');
      params.delete('contact_posted');
      var next = window.location.pathname;
      var q = params.toString();
      if (q) next += '?' + q;
      window.history.replaceState({}, '', next + window.location.hash);
    } catch (err2) {
      /* ignore */
    }
  }

  function init() {
    syncFormAvailability();
    showPostedSuccessIfNeeded();
  }

  document.addEventListener('submit', onSubmit, false);
  window.addEventListener('resize', syncFormAvailability);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
